import type { ExportRange } from '../../../../renderer/src/export-range';

export const MINIMUM_FOOTAGE_FRAMES = 150;
const clamp = (value: number, low: number, high: number) => Math.max(low, Math.min(high, Math.round(value)));

/** Keep every accepted selection at least five seconds long, including both endpoints. */
export function enforceFootageRange(range: ExportRange, last: number): ExportRange {
  const minimum = Math.min(MINIMUM_FOOTAGE_FRAMES, last + 1);
  let inFrame = clamp(range.inFrame, 0, last);
  const outFrame = clamp(Math.max(range.outFrame, inFrame + minimum - 1), 0, last);
  inFrame = Math.min(inFrame, outFrame - minimum + 1);
  return { ...range, inFrame, outFrame };
}
export function footageBoundaryLimits(range: ExportRange, kind: 'in' | 'out', last: number) {
  const minimum = Math.min(MINIMUM_FOOTAGE_FRAMES, last + 1);
  return kind === 'in' ? { first: 0, last: range.outFrame - minimum + 1 }
    : { first: range.inFrame + minimum - 1, last };
}
export function moveFootageBoundary(range: ExportRange, kind: 'in' | 'out', frame: number, last: number): ExportRange {
  const limits = footageBoundaryLimits(range, kind, last);
  return { ...range, [kind === 'in' ? 'inFrame' : 'outFrame']: clamp(frame, limits.first, limits.last) };
}
